<template>
  <button
    class="btn btn-primary"
    :disabled="loading || disabled"
    title="Select domain as default"
    v-tooltip="'Select domain as default'"
    @click="onSelectButtonClick($event)"
  >
    <i class="fas fa-fw" :class="{'fa-spinner fa-spin': loading, 'fa-check': !loading}"></i>
  </button>
</template>

<script>
import {selectEmailDomain} from '../../../utility/api/vessel/selectEmailDomain';

export default {
  name: 'select-email-domain-button',
  props: {
    domain: {
      type: Object,
      required: true,
    },
    disabled: Boolean
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onSelectButtonClick(event) {
      event.stopPropagation();

      this.loading = true;
      selectEmailDomain(this.domain.id).then(
        () => {
          this.loading = false;
          this.$emit('refresh-domains');
        },
        () => (this.loading = false)
      );
    },
  },
};
</script>
